/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/',
    name: 'GlobalLayout',
    component: () => import('@/components/page/GlobalLayout'),
    children:[
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/Home.vue')
      },
      {
        path: '/MyCenter',
        name: 'MyCenter',
        component: () => import('../views/person/MyCenter.vue')
      }
    ]
  },
  {
    path: '/subApplication/*',
    name: '/subApplication',
    component: () => import('@/components/page/GlobalLayoutSub'),
    // children:[
    //   {
    //     path: '/GovernmentGuideWeb',
    //     name: 'GovernmentGuideWeb'
    //   },
    // ]
  },  
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '../views/exception/404')
  }
]
